<template>
<div>
  <v-container
    fluid
    fill-height
  >

    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        sm6
        md4
      >
        <v-menu
          ref="menu"
          :close-on-content-click="false"
          v-model="menu"
          :nudge-right="140"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          min-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="dataInFormatted"
            label="Data Inicial"
            readonly
            persistent-hint
            prepend-icon="event"
            @blur="dataIn = parseDate(dataInFormatted)"
          ></v-text-field>
            <v-date-picker
              locale="pt-br"
              v-model="dataIn"
              no-title
              @input="menu = false"
            ></v-date-picker>
              </v-menu>

              </v-flex>
              <v-flex
                xs12
                sm6
                md4
              >
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="menu2"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dataFimFormatted"
                    label="Data Final"
                    persistent-hint
                    prepend-icon="event"
                    @blur="dataFim = parseDate(dataFimFormatted)"
                  ></v-text-field>
                    <v-date-picker
                      locale="pt-br"
                      v-model="dataFim"
                      no-title
                      @input="menu2 = false"
                    ></v-date-picker>
                      </v-menu>
                      </v-flex>
                      <v-flex>
                        <v-btn
                          class="white--text"
                          @click="filtrar()"
                          color="sucesso"
                          value="justify"
                        >Filtrar

                          <v-icon color="white darken-2" right>filter_list</v-icon> 
                          </v-btn>
                      </v-flex>
                      <v-flex >
                        <v-btn
                          class="white--text"
                          @click="buscaExtratoCartaoPdf()"
                          id="btnPDF"
                          ref="btnPDF"
                          color="orange"
                          value="justify"
                        >
                          PDF
                          <v-icon right>tab</v-icon>
                          </v-btn>
                      </v-flex>
                      <v-flex xs12>
                        <v-progress-linear
                          v-show="progressTable"
                          slot="progress"
                          color="primary"
                          indeterminate
                        ></v-progress-linear>

                          <v-data-table
                            :headers="headers"
                            :items="items"
                            :loading="false"
                            rows-per-page-text="registros por página"
                            no-data-text="Nenhum resultado encontrado!"
                            no-results-text="Nenhum resultado encontrado!"
                            class="elevation-1"
                          >

                            <template
                              slot="headerCell"
                              slot-scope="props"
                            >
                              <v-tooltip bottom>
                                <span slot="activator">
                        {{ props.header.text }}
                        </span>
                                <span>
                        {{ props.header.text }}
                        </span>
                              </v-tooltip>
                              </template>
                              <template
                                slot="items"
                                slot-scope="props"
                              >
                                <td class="text-xs-left">{{ props.item.data }}</td>
                                <td class="text-xs-left">{{ props.item.loja }}</td>
                                <td class="text-xs-right">{{ formata_moeda(props.item.valor) }}</td>
                                <td class="text-xs-right">{{ formata_moeda(props.item.valor_bonus) }}</td>
                                <td class="text-xs-right">{{ formata_valor(props.item.perc_bonus) }}</td>
                                <td class="text-xs-left">{{ props.item.sinalop }}</td>
                              

                                </template>
                                <template
                                  slot="pageText"
                                  slot-scope="{ pageStart, pageStop }"
                                >
                                  de{{ pageStart }} até {{ pageStop }}
                                  </template>
                                  </v-data-table>

                      </v-flex>
                      </v-layout>
                      </v-container>

</div>
</template>


<script>
import { HTTP } from "../services/http.axios";
import { formata } from "../services/format";
import EventBus from "../services/EventBus";

var moment = require("moment");

export default {
  name: "Extrato",
  mixins: [formata],
  props: ["cartao", "openDialog"],
  mounted() {
    // alert(this.openDialog);
    this.items = [];

    //EventBus.$off("buscaExtratoCartao");
    let self = this;
    EventBus.$on("buscaExtratoCartao", function() {
      self.items = [];
      self.buscaExtratoCartao(self.dataIn, self.dataFim);
    });

    this.progressTable = false;
  },
  data: () => ({
    dataIn: moment().format("YYYY-MM-01"),
    extrato: [],
    progressTable: false,
    dataInFormatted: moment().format("01/MM/YYYY"),
    menu: false,
    menu2: false,
    dataFim: moment().format("YYYY-MM-DD"),
    dataFimFormatted: moment().format("DD/MM/YYYY"),
    // idFranquia: localStorage.getItem("tituloApp"),

    headers: [
      {
        text: "Data|Hora",
        sortable: true,
        align: "left",
        value: "datahora"
      },
      {
        text: "Loja",
        align: "left",
        value: "loja"
      },
      {
        text: "Valor",
        align: "right",
        value: "valor"
      },
      {
        text: "Valor Bônus",
        align: "right",
        value: "valor_bonus"
      },
      {
        text: "Perc. Bônus",
        align: "right",
        value: "perc_bonus"
      },
      {
        text: "",
        value: "sinalop",
        sortable: false
      }
    ],
    items: []
  }),

  computed: {
    computedDateFormatted() {
      return this.formatDate(this.dataIn);
    },
    selcartao(){
      //alert(this.selcartao);
    }
  },

  watch: {
    dataIn(val) {
      this.dataInFormatted = this.formatDate(this.dataIn);
    },
    dataFim(val) {
      this.dataFimFormatted = this.formatDate(this.dataFim);
    },
    cartao(val) {
      //this.buscaExtratoCartao(this.dataIn, this.dataFim);
    }
  },

  methods: {
    filtrar() {
      this.buscaExtratoCartao(this.dataIn, this.dataFim);
    },
    formata_moeda(val) {
      let val1 = val / 100;
      let valor = this.formatar_moeda(val1);
      return valor;
    },

    formata_valor(val) {
      let val1 = val / 100;
      let valor = this.formatar_valor(val1);
      return valor;
    },
    buscaExtratoCartaoPdf() {
      this.progressTable = true;

      HTTP.get(
        `cartao/extrato/pdf/` +
          this.cartao +
          "/" +
          this.dataIn +
          "/" +
          this.dataFim
      ).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.extrato =
          console.log(response.data.movimentacao);
          document.getElementById("linkDownload").href = response.data.url;
          //document.getElementById("linkDownload").download =
          // '"http://192.168.1.135:75/GKFq70ibiI38urfHml.pdf"';
          document.getElementById("linkDownload").click();
          //this.items = response.data.movimentacao;
          //this.mostraCartoes = true;
        }
        this.progressTable = false;
      });
    },

    buscaExtratoCartao(dataIn, dataFim) {
      this.progressTable = true;
      HTTP.get(
        `cartao/extrato/` + this.cartao + "/" + dataIn + "/" + dataFim
      ).then(response => {
        if (response.data.error) {
          this.textSnack = response.data.error;
          this.snackbar = true;
        } else {
          //this.extrato =
          console.log(response.data.movimentacao);
          this.items = response.data.movimentacao;
          this.mostraCartoes = true;
        }
        this.progressTable = false;
      });
    },

    //mudar para um mixed
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  }
};
</script>


<style>
#container {
  margin-top: 115px;
}
</style>



// WEBPACK FOOTER //
// src/components/Extrato.vue